// The code the API puts at the start of the error when a save in place is refused because someone else
// saved the version after the author opened it.
export const VERSION_SAVED_ELSEWHERE = 'NOVA_VERSION_SAVED_ELSEWHERE';

export function versionSavedElsewhereError(): Error {
	return Object.assign(new Error('version saved elsewhere since it was opened'), {code: VERSION_SAVED_ELSEWHERE});
}

export function isVersionSavedElsewhereError(error: unknown): boolean {
	return error instanceof Error && (error as Error & {code?: string}).code === VERSION_SAVED_ELSEWHERE;
}
